import { render, staticRenderFns } from "./BundlesTab.vue?vue&type=template&id=9bf2dcdc&"
import script from "./BundlesTab.vue?vue&type=script&lang=js&"
export * from "./BundlesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports